module.exports = __webpack_public_path__ + "react/fonts/checkbox-true.1f6303ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/checkbox-true.svg
// module id = 1903
// module chunks = 0